export const OUT_GOING_CALL = 10009
export const INCOMING_CALL = 10010
export const TEXT_MESSAGE = 10011
export const EMAIL = 10012
export const MEETING = 10013
export const DIRECT_MAIL = 10014
// just for timeline front end
export const SHARED_NOTE = -1

let activityTypes = new Map()
activityTypes.set(10009, 'OUT_GOING_CALL')
activityTypes.set(10010, 'INCOMING_CALL')
activityTypes.set(10011, 'TEXT_MESSAGE')
activityTypes.set(10012, 'EMAIL')
activityTypes.set(10013, 'MEETING')
activityTypes.set(10014, 'DIRECT_MAIL')

export const getActivityName = (id) => {
  return activityTypes.get(id)
}

export const getNormalizedActivityName = (id) => {
  switch (id) {
    case OUT_GOING_CALL:
      return 'Outgoing Call'
    case INCOMING_CALL:
      return 'Incoming Call'
    case TEXT_MESSAGE:
      return 'Text Message'
    case EMAIL:
      return 'Email'
    case MEETING:
      return 'Meeting'
    case DIRECT_MAIL:
      return 'Direct Mail'
    default:
      return ''
  }
}
